import nonEmptyString from './nonEmptyStringValidator.js'

// Note that this file mirrors a validation rule in the backend

export default function (input) {
    const regex = /^[\d]{8}$/
    return !!(nonEmptyString(input) && !!input.match(regex))
}
